
import apiClient from '@u/apiClient'

export default {
  fetchScheduledTaskList() {
    return new Promise((resolve, reject) => {
      apiClient
        .get('scheduled-task')
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTasksByTemplateId(_, templateId) {
    return new Promise((resolve, reject) => {
      apiClient
        .get('scheduled-task', { params: { schedulable_id: templateId } })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  fetchScheduledTaskById(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`scheduled-task/${id}`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  createScheduledTask(_, data) {
    return new Promise((resolve, reject) => {
      apiClient
        .post('scheduled-task', data, {
          skipValidationToast: data.action === 'close_supplier_orders'
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  updateScheduledTask(_, { id, data }) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(`scheduled-task/${id}`, data, {
          skipValidationToast: data.action === 'close_supplier_orders'
        })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  toggleScheduledTask(_, { id, active }) {
    return new Promise((resolve, reject) => {
      apiClient
        .patch(`scheduled-task/${id}`, { active })
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  duplicateScheduledTask(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`scheduled-task/${id}/duplicate`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },

  deleteScheduledTask(_, id) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`scheduled-task/${id}`)
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  }
}
